import { FC, forwardRef } from 'react';
import classNames from 'classnames/bind';
import { Theme } from '../../types/enums';
import { FAIcon, IconStyle } from '../Icons/Icons';
import { CheckboxPropsTypes, CheckboxTheme } from './types/propsType';
import styles from './Checkbox.module.scss';
import { CheckboxVariant } from './types/enums';
const cx = classNames.bind(styles);

const Checkbox: FC<CheckboxPropsTypes> = forwardRef<HTMLInputElement, CheckboxPropsTypes>(
  ({ text, disabled, checked = false, theme = Theme.BLACK, variant, subText, id, ...restProps }, ref) => {
    function renderInputType() {
      return (
        <input
          id={`checkbox-${id}`}
          ref={ref}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          data-testid="checkbox-test-id"
          {...restProps}
        />
      );
    }

    const checkboxBorderClass = checked ? 'checkbox-border-filled' : 'checkbox-border-empty';

    const variantClassName = cx({
      [CheckboxVariant.DEFAULT]: variant !== CheckboxVariant.LONG_TEXT,
      [CheckboxVariant.LONG_TEXT]: variant === CheckboxVariant.LONG_TEXT,
    });

    const ClabelClassname = cx('checkbox', variantClassName, theme, checkboxBorderClass, { disabled: disabled });

    return (
      <label className={ClabelClassname} data-testid="checkbox-container-test-id">
        <section className={styles['checkbox-main-content']}>
          {renderInputType()}
          <span className={`${styles['checkbox-border']}`}>
            <FAIcon
              iconName={checked ? 'check' : 'square'}
              iconStyle={checked ? IconStyle.SOLID : IconStyle.REGULAR}
              theme={theme}
              className={`${styles['checkmark']}`}
            />
          </span>
          <label htmlFor={`checkbox-${id}`} className={styles['checkbox-content']}>
            <span className={styles['label']}>{text}</span>
          </label>
        </section>
        {subText && <span className={styles['label-details']}>{subText}</span>}
      </label>
    );
  },
);
Checkbox.displayName = 'Checkbox';
export default Checkbox;
export type { CheckboxTheme };
